import * as Constants from "../common/Constants";
import cloneDeep from "lodash/cloneDeep";

const initialState = {
    challanInvoices: [],
    challanInvoice: null,
    filteredChallanInvoices: [],
    isLoading: false,
    isUpdating: false,
    isUpdated: false,
    isPosting: false,
    isPosted: false,
    count: 0,
    page: 1,
    pageSize: 10,
    error: null
};

export default function challanInvoiceReducer(state = initialState, action) {

    var newState;
    switch (action.type) {
        case Constants.REQUEST_GET_CHALLAN_INVOICE:
        case Constants.REQUEST_GET_SINGLE_CHALLAN:
        case Constants.REQUEST_GET_FILTER_CHALLAN:
            newState = {
                ...state,
                isLoading: true,
                isPosting: false,
                isPosted: false,
                error: null
            };
            return newState;

        case Constants.REQUEST_ADD_CHALLAN_INVOICE:
            newState = { ...state };
            newState.isPosted = false;
            newState.error = null;
            newState.isPosting = true;
            return newState;

        case Constants.SUCCESS_ADD_CHALLAN_INVOICE:
            newState = { ...state };
            newState.isPosting = false;
            newState.error = null;
            newState.isPosted = true;
            newState.challanInvoice = action.payload;
            return newState;

        case Constants.SUCCESS_GET_FILTER_CHALLAN:
            newState = { ...state };
            newState.isPosting = false;
            newState.isLoading = false;
            newState.error = null;
            newState.isPosted = false;
            newState.filteredChallanInvoices = action.payload;
            return newState;

        case Constants.FAILED_ADD_CHALLAN_INVOICE:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.error = action.error;
            return newState;

        case Constants.REQUEST_DELETE_CHALLAN_INVOICE:
        case Constants.REQUEST_UPDATE_CHALLAN_INVOICE:
            newState = {
                ...state,
                isUpdating: true
            }
            return newState;

        case Constants.SUCCESS_DELETE_CHALLAN_INVOICE:
            newState = { ...state };
            newState.isUpdating = false;
            newState.isUpdated = true;
            if (action.id) newState.challanInvoices = state.challanInvoices.filter(a => a.id !== action.id);
            return newState;

        case Constants.SUCCESS_UPDATE_CHALLAN_INVOICE:
            newState = { ...state };
            newState.isUpdating = false;
            newState.isUpdated = true;
            //if (action.id) newState.challanInvoices = state.challanInvoices.filter(a => a.id !== action.id);
            return newState;

        case Constants.FAILED_DELETE_CHALLAN_INVOICE:
        case Constants.FAILED_UPDATE_CHALLAN_INVOICE:
            newState = {
                ...state,
                isUpdating: false,
                error: action.error
            }
            return newState;

        case Constants.SUCCESS_GET_CHALLAN_INVOICE:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.challanInvoices = action.payload.items;
            return newState;

        case Constants.SUCCESS_GET_SINGLE_CHALLAN:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = null;
            newState.challanInvoice = action.payload;
            return newState;

        case Constants.FAILED_GET_CHALLAN_INVOICE:
        case Constants.FAILED_GET_SINGLE_CHALLAN:
        case Constants.FAILED_GET_FILTER_CHALLAN:
            newState = { ...state };
            newState.isPosting = false;
            newState.isPosted = false;
            newState.isLoading = false;
            newState.error = action.error;
            return newState;

        case Constants.RESET_CHALLAN_INVOICE:
            newState = {
                challanInvoices: [],
                challanInvoice: null,
                filteredchallanInvoices: [],
                isLoading: false,
                isUpdating: false,
                isUpdated: false,
                isPosting: false,
                isPosted: false,
                count: 0,
                page: 1,
                pageSize: 10,
                error: null
            };
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ChallanInvoiceReducer.js